<aside class="app-sidebar" [class.open]="open" [class.collapsed]="collapsed" id="appSidebar" aria-label="App navigation">
  <div class="sb-brand">
    <a class="sb-logo" routerLink="/home" aria-label="Innovnet home" (click)="onNav()">
      <img src="/innovnet_icon.png" alt="Innovnet" class="innovnet-icon" />
      <span class="sb-wordmark">Innovnet</span>
    </a>
  </div>

  <nav class="sb-nav" aria-label="Primary">
    <a class="sb-link" routerLink="/home" routerLinkActive="active" (click)="onNav()">
      <i class="fas fa-home" aria-hidden="true"></i>
      <span>Home</span>
      <span class="sb-new">New</span>
    </a>
    <a class="sb-link" routerLink="/insights" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="onNav()">
      <i class="fas fa-chart-line" aria-hidden="true"></i>
      <span>Insights</span>
    </a>
    <a class="sb-link" routerLink="/customTheme" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="onNav()">
      <i class="fas fa-palette" aria-hidden="true"></i>
      <span>My Profile</span>
    </a>
    <a class="sb-link" routerLink="/exchangedContacts" [class.active]="isContactsSectionActive()" (click)="onNav()">
      <i class="fas fa-address-book" aria-hidden="true"></i>
      <span>Contacts</span>
    </a>
    <a
      class="sb-link"
      [routerLink]="isSubscriptionActive ? '/card-mode' : null"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      [class.active]="isCardModeActive()"
      (click)="openCardMode($event)">
      <i class="fas fa-sliders-h" aria-hidden="true"></i>
      <span>Card Mode</span>
    </a>
    <a class="sb-link" routerLink="/scan" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="onNav()">
      <i class="fas fa-expand" aria-hidden="true"></i>
      <span>Scan</span>
    </a>
    <!-- Events stays off the sidebar until EVENTS_FEATURE_ENABLED. The /events route is still registered behind that flag. -->
    <a *ngIf="isAdmin" class="sb-link" routerLink="/admin" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="onNav()">
      <i class="fas fa-shield-alt" aria-hidden="true"></i>
      <span>Admin</span>
    </a>
  </nav>

  <nav class="sb-nav sb-nav-tools" aria-label="Tools">
    <a class="sb-link" href="#" (click)="openAIAssistant($event)">
      <i class="fas fa-robot" aria-hidden="true"></i>
      <span>AI Assistant</span>
    </a>

    <div class="sb-settings" [class.open]="settingsOpen">
      <button type="button" class="sb-link sb-link-btn" [class.active]="isSettingsActive() || settingsOpen" (click)="toggleSettings($event)" [attr.aria-expanded]="settingsOpen">
        <i class="fas fa-cog" aria-hidden="true"></i>
        <span>Settings</span>
        <i class="fas fa-chevron-down sb-chevron" aria-hidden="true"></i>
      </button>
      <div class="sb-flyout" *ngIf="settingsOpen" role="menu">
        <a class="sb-flyout-item" routerLink="/settings" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="onSettingsNav()">
          All Settings
        </a>
        <a
          class="sb-flyout-item"
          *ngFor="let section of getActiveSections()"
          [routerLink]="['/settings']"
          [fragment]="section.id"
          [class.active]="isSettingsSectionActive(section.id)"
          (click)="onSettingsNav()">
          <i [class]="section.icon" aria-hidden="true"></i>
          <span class="sb-flyout-label">{{ section.title }}</span>
          <span class="pro-badge" *ngIf="section.pro">PRO</span>
        </a>
        <ng-container *ngIf="isNonProduction && getInactiveSections().length > 0">
          <a class="sb-flyout-item is-disabled" *ngFor="let section of getInactiveSections()">
            {{ section.title }} (Coming Soon)
          </a>
        </ng-container>
      </div>
    </div>

    <a *ngIf="profileLink" class="sb-link" [href]="profileLink" target="_blank" rel="noopener" title="Open your public profile" (click)="onNav()">
      <i class="fas fa-user" aria-hidden="true"></i>
      <span>Public profile</span>
      <i class="fas fa-external-link-alt sb-ext" aria-hidden="true"></i>
    </a>
  </nav>

  <div class="sb-spacer"></div>

  <div class="sb-theme">
    <ui-theme-control></ui-theme-control>
  </div>

  <div class="sb-account">
    <button
      type="button"
      class="sb-pin"
      *ngIf="showEventsFeature && pinnedEvent.pinned && pinnedEvent.event_name"
      (click)="goToPinnedEvent()"
      [attr.title]="'NFC taps tagged to ' + pinnedEvent.event_name">
      {{ pinnedEvent.event_name }}
    </button>

    <div class="sb-user" *ngIf="userDisplayName">
      <button type="button" class="sb-bell" (click)="toggleNotifications($event)" [attr.aria-label]="unreadNotifications + ' unread notifications'">
        <i class="fas fa-bell" aria-hidden="true"></i>
        <span class="sb-count" *ngIf="unreadNotifications > 0">{{ unreadNotifications > 99 ? '99+' : unreadNotifications }}</span>
      </button>
      <div class="sb-notes" *ngIf="notesOpen">
        <p *ngIf="notesError">Couldn't load. <button type="button" (click)="loadNotes()">Retry</button></p>
        <p *ngIf="!notesError && notableEvents.length === 0">No notifications yet.</p>
        <ul>
          <li *ngFor="let event of notableEvents">{{ event.title }}</li>
        </ul>
        <button type="button" (click)="markNotesRead()">Mark all read</button>
      </div>
      <span class="sb-avatar" aria-hidden="true">{{ userInitials }}</span>
      <span class="sb-user-meta">
        <span class="sb-user-label">Signed in as</span>
        <strong class="sb-user-name">{{ userDisplayName }}</strong>
        <span class="sb-plan" *ngIf="planLine as plan">
          <span *ngIf="!plan.upgrade">{{ plan.text }}</span>
          <a *ngIf="plan.upgrade" routerLink="/settings" fragment="billing" (click)="onNav()">{{ plan.text }} · Upgrade</a>
        </span>
      </span>
    </div>

    <a
      class="sb-upgrade"
      *ngIf="isAuthenticated"
      routerLink="/refer"
      routerLinkActive="is-on"
      (click)="onNav()">
      <i class="fas fa-gift" aria-hidden="true"></i>
      <span>Refer</span>
    </a>

    <button
      type="button"
      class="sb-upgrade"
      *ngIf="showUpgradeCta"
      (click)="goUpgrade()">
      <i class="fas fa-arrow-up" aria-hidden="true"></i>
      <span>Upgrade</span>
    </button>

    <button type="button" class="sb-signout" (click)="signOut()" [disabled]="isSigningOut">
      <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
      <span>{{ isSigningOut ? 'Signing out…' : 'Sign out' }}</span>
    </button>
  </div>

  <div class="sb-legal">
    <span class="sb-copy">&copy; {{ currentYear }} Innovnet</span>
    <div class="sb-legal-links">
      <a [href]="companyWebsiteUrl" target="_blank" rel="noopener" title="Visit Innovnet">
        <i class="fas fa-globe" aria-hidden="true"></i>
        <span>Website</span>
      </a>
      <a [href]="'mailto:' + infoEmail" title="Contact">
        <i class="fas fa-envelope" aria-hidden="true"></i>
        <span>Contact</span>
      </a>
    </div>
  </div>
</aside>
